module.exports = __webpack_public_path__ + "img/tower_bridge.5464fe8d.jpg";